'use client';

import {styled} from "@mui/system";
import CustomTitleContainer from "@/src/mui-custom/title/custom-title-container";

const CardTitleContainer = styled(CustomTitleContainer)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '.5rem',
    width: '100%',
    gap: '0',
}));

export default CardTitleContainer;
